<div class="px-3">
  <div class="ps-1 pt-3 pb-3">
    <b [attr.data-test-id]="'patient-diseases-title'" class="text-break py-md-1">
      {{ 'PROFILE_VIEW_PATIENT_ILLNESSES_HINT' | translate }}:
    </b>
    <span [attr.data-test-id]="'diseases'">
      {{ diseases | formatCategories }}
    </span>
  </div>
</div>
